import * as React from 'react';
import Space from 'antd/lib/space';
import { useParams } from 'react-router-dom';
import { useTrackPageView } from '@/helpers/trackingHelpers';
import { AppComponentProps, AppRouteComponentMatchParams } from '@/typescriptHelpers';
import AppReleaseDefaults from '../AppReleaseDefaults';
import ReleaseNoteDefaultsComponent from './ReleaseNoteDefaultsComponent';

const AppStoreSettingsComponent: React.FC<AppComponentProps> = (props: AppComponentProps) => {
    const { appId, orgId } = props;
    const { appIdParam } = useParams<AppRouteComponentMatchParams>();

    useTrackPageView('App Store Defaults', [appIdParam]);

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'stretch',
                justifyContent: 'center',
                flexDirection: 'column',
                paddingBottom: 65,
            }}
        >
            <Space direction="vertical" size={40}>
                <AppReleaseDefaults appId={appId} orgId={orgId} />
                <ReleaseNoteDefaultsComponent appId={appId} orgId={orgId} />
            </Space>
        </div>
    );
};

export default AppStoreSettingsComponent;
